import { useInsightApi } from "hooks/use-insight-api";
import React, { useState, useRef, useEffect } from "react";

interface UserActionLink {
  text: string;
  url: string;
}

interface HeaderUserProps {
  user: string;
  userActionLinks: UserActionLink[];
  logout: () => void;
}

const HeaderUser: React.FC<HeaderUserProps> = ({ user, userActionLinks, logout }) => {
    const [showUserDropDown, setShowUserDropDown] = useState(false);
    const dropDownRef = useRef<HTMLDivElement>(null);
    const { clearUserHierarchySelections } = useInsightApi();

    const handleLogout = () => {
        clearUserHierarchySelections();
        logout();
    };

    const toggleUserDropDown = () => {
        setShowUserDropDown(!showUserDropDown);
    };

    const closeUserDropDown = (e: MouseEvent) => {
        if(showUserDropDown && !dropDownRef.current?.contains(e.target as Node)){
            setShowUserDropDown(false);
        }
    }

    const userActionsList = Array.isArray(userActionLinks)
        ? userActionLinks.map((liElement) => (
            <li key={liElement.text.replaceAll(' ', '')}>
            <a href={liElement.url}>{liElement.text}</a>
            </li>
        ))
        : null;
    
    useEffect(() => {
        document.addEventListener('mousedown', closeUserDropDown);
    }, [showUserDropDown]);

    return (
        <div
            ref={dropDownRef}
            id="cui-user_dropdown"
            className={`cui-c_dropdown ${showUserDropDown ? "show-dropdown" : ""}`}
        >
            <a onClick={() => toggleUserDropDown()}>
                <span>{user}</span>
            </a>
            <ul>
                {userActionsList}
                <li>
                    <a onClick={handleLogout}>Sign out</a>
                </li>
            </ul>
        </div>
    );
};

export default HeaderUser;